import React from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { FreeTextInput } from '@/features/editor/widgets/ai-component/inputs/shared/free-text-input';

export interface GenericJsStringInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function GenericJsStringInput({
  value,
  onChange,
}: GenericJsStringInputProps) {
  return (
    <InlineInputCardWrapper
      style={{ display: `grid`, gridTemplateColumns: `auto 1fr`, gap: `2rem` }}
    >
      <span>Text Input</span>
      <FreeTextInput initialValue={value} onChange={onChange} />
    </InlineInputCardWrapper>
  );
}
